import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import SwipeableTab from './SwipeableTab';

export class SwipeableTabs extends React.Component {
  static propTypes = {
    tabIndex: PropTypes.number,
    tabsPosition: PropTypes.oneOf(['top', 'bottom']),
    className: PropTypes.string,
    onTabChange: PropTypes.func,
    tabsProps: PropTypes.object,
    swipeableViewsProps: PropTypes.object,
    children: PropTypes.node.isRequired
  }

  static defaultProps = {
    tabsPosition: 'top',
    tabsProps: {},
    swipeableViewsProps: {}
  }

  state = {
    tabIndex: 0
  }

  setTabIndex(tabIndex) {
    this.setState({tabIndex});
  }

  handleChangeTab = (event, tabIndex) => {
    this.handleSwipe(tabIndex);
  }

  handleSwipe = nextTabIndex => {
    const {onTabChange} = this.props;

    if (onTabChange) {
      const currentTabIndex = this.state.tabIndex;
      onTabChange(nextTabIndex, currentTabIndex);
    }

    this.setTabIndex(nextTabIndex);
  }

  renderTab = (swipeableTab, index) => {
    if (swipeableTab.type !== SwipeableTab) {
      return null;
    }

    const tabComponent = swipeableTab.props.tabComponent;

    if (tabComponent) {
      return tabComponent;
    }

    const {label, tabProps} = swipeableTab.props;
    let {id, key} = swipeableTab.props;

    if (id) {
      id = `${id}Tab`;
    }

    if (!key) {
      key = (id || index);
    }

    return (
      <Tab
        id={id}
        key={key}
        label={label}
        {...tabProps}
      />
    );
  }

  renderTabs() {
    const {className, tabsProps, children} = this.props;

    return (
      <div className={className}>
        <Tabs
          value={this.state.tabIndex}
          onChange={this.handleChangeTab}
          {...tabsProps}
        >
          {React.Children.map(children, this.renderTab)}
        </Tabs>
      </div>
    );
  }

  renderTopTabs() {
    if (this.props.tabsPosition === 'bottom') {
      return null;
    }
    
    return this.renderTabs();
  }

  renderBottomTabs() {
    if (this.props.tabsPosition === 'bottom') {
      return this.renderTabs();
    }

    return null;
  }

  renderOtherChildren() {
    return React.Children.map(this.props.children, child => {
      if (child.type === SwipeableTab) {
        return null;
      }

      return child;
    });
  }

  renderTabsContainer() {
    return React.Children.map(this.props.children, child => {
      if (child.type === SwipeableTab) {
        return child;
      }

      return null;
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.renderTopTabs()}
        
        {this.renderOtherChildren()}

        <SwipeableViews
          index={this.state.tabIndex}
          onChangeIndex={this.handleSwipe}
          {...this.props.swipeableViewsProps}
        >
          {this.renderTabsContainer()}
        </SwipeableViews>

        {this.renderBottomTabs()}
      </React.Fragment>
    );
  }

  static getDerivedStateFromProps(nextProps) {
    const {tabIndex} = nextProps;

    if (tabIndex) {
      return {tabIndex};
    }

    return {};
  }
}

export default SwipeableTabs;
